// Generated by scripts/generate.mjs. Do not edit by hand.

export const contractSchemas = Object.freeze({
  "candidate-reply.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/candidate-reply.v1.schema.json",
    "title": "CandidateReplyV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "body",
      "replyKinds",
      "logicalSendKey"
    ],
    "properties": {
      "schemaVersion": {
        "const": "candidate-reply.v1"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "body": {
        "type": "string",
        "minLength": 1,
        "maxLength": 4096
      },
      "replyKinds": {
        "type": "array",
        "minItems": 1,
        "maxItems": 6,
        "uniqueItems": true,
        "items": {
          "type": "string",
          "enum": [
            "ACK",
            "ANSWER",
            "CLARIFICATION",
            "HANDOFF",
            "QUESTION",
            "ERROR"
          ]
        }
      },
      "primaryQuestionId": {
        "$ref": "#/$defs/id"
      },
      "presentation": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "mode",
          "fallbackBody",
          "controlId",
          "options"
        ],
        "properties": {
          "mode": {
            "type": "string",
            "enum": [
              "TEXT",
              "BUTTONS",
              "LIST"
            ]
          },
          "fallbackBody": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4096
          },
          "controlBody": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4096
          },
          "actionLabel": {
            "type": "string",
            "minLength": 1,
            "maxLength": 20
          },
          "controlId": {
            "$ref": "#/$defs/id"
          },
          "options": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "id",
                "label"
              ],
              "properties": {
                "id": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 120
                },
                "label": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 240
                }
              }
            }
          }
        }
      },
      "logicalSendKey": {
        "type": "string",
        "minLength": 1,
        "maxLength": 200,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "checklist-state.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/checklist-state.v1.schema.json",
    "title": "ChecklistStateV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "sessionId",
      "stateVersion",
      "items"
    ],
    "properties": {
      "schemaVersion": {
        "const": "checklist-state.v1"
      },
      "sessionId": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128
      },
      "stateVersion": {
        "type": "integer",
        "minimum": 0
      },
      "items": {
        "type": "array",
        "maxItems": 200,
        "items": {
          "$ref": "#/$defs/checklistItem"
        }
      }
    },
    "$defs": {
      "checklistItem": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fieldKey",
          "answerType",
          "state",
          "required",
          "riskTier",
          "conditionalOn",
          "options",
          "targetRevision"
        ],
        "properties": {
          "fieldKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "answerType": {
            "$ref": "#/$defs/answerType"
          },
          "state": {
            "$ref": "#/$defs/itemState"
          },
          "required": {
            "type": "boolean"
          },
          "riskTier": {
            "$ref": "#/$defs/riskTier"
          },
          "conditionalOn": {
            "$ref": "#/$defs/conditionalOn"
          },
          "options": {
            "type": [
              "array",
              "null"
            ],
            "maxItems": 50,
            "items": {
              "$ref": "#/$defs/option"
            }
          },
          "targetRevision": {
            "type": [
              "number",
              "null"
            ]
          }
        }
      },
      "answerType": {
        "type": "string",
        "enum": [
          "BOOLEAN",
          "DATE",
          "RADIO",
          "MULTISELECT",
          "FILE",
          "TEXT",
          "NUMBER",
          "TEXT_AREA",
          "LIST_OBJECT"
        ]
      },
      "itemState": {
        "type": "string",
        "enum": [
          "MISSING",
          "PROPOSED",
          "AWAITING_CONFIRMATION",
          "SATISFIED",
          "SKIPPED"
        ]
      },
      "riskTier": {
        "type": "string",
        "enum": [
          "NORMAL",
          "HIGH"
        ]
      },
      "conditionalOn": {
        "type": [
          "object",
          "null"
        ],
        "additionalProperties": false,
        "required": [
          "fieldKey",
          "answerKey"
        ],
        "properties": {
          "fieldKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "answerKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          }
        }
      },
      "option": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "label"
        ],
        "properties": {
          "key": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "label": {
            "type": "string",
            "minLength": 1,
            "maxLength": 240
          }
        }
      }
    }
  },
  "commit-outcome.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/commit-outcome.v1.schema.json",
    "title": "CommitOutcomeV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "status",
      "acceptedRelatedChanges",
      "rejectedChanges",
      "sideResults",
      "completed",
      "takeoverEpoch"
    ],
    "properties": {
      "schemaVersion": {
        "const": "commit-outcome.v1"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "status": {
        "type": "string",
        "enum": [
          "COMMITTED",
          "PARTIAL",
          "REJECTED",
          "STALE",
          "REVIEW"
        ]
      },
      "acceptedAnswer": {
        "$ref": "#/$defs/acceptedChange"
      },
      "acceptedRelatedChanges": {
        "type": "array",
        "maxItems": 3,
        "items": {
          "$ref": "#/$defs/acceptedChange"
        }
      },
      "rejectedChanges": {
        "type": "array",
        "maxItems": 4,
        "items": {
          "$ref": "#/$defs/rejectedChange"
        }
      },
      "sideResults": {
        "type": "array",
        "maxItems": 2,
        "items": {
          "$ref": "#/$defs/sideResult"
        }
      },
      "recruiterResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "timing",
          "status"
        ],
        "properties": {
          "timing": {
            "type": "string",
            "enum": [
              "NOW",
              "AFTER_ONBOARDING"
            ]
          },
          "status": {
            "type": "string",
            "enum": [
              "PERSISTED",
              "HANDED_OFF",
              "REJECTED"
            ]
          }
        }
      },
      "authoritativeQuestion": {
        "$ref": "#/$defs/questionPresentation"
      },
      "completed": {
        "type": "boolean"
      },
      "newStateVersion": {
        "$ref": "#/$defs/opaqueVersion"
      },
      "takeoverEpoch": {
        "$ref": "#/$defs/opaqueVersion"
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "opaqueVersion": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128
      },
      "operation": {
        "type": "string",
        "enum": [
          "SET",
          "ADD",
          "REMOVE",
          "CLEAR"
        ]
      },
      "acceptedChange": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "targetQuestionKey",
          "targetQuestionVersion",
          "operation",
          "commitReference",
          "sensitive"
        ],
        "properties": {
          "kind": {
            "type": "string",
            "enum": [
              "CURRENT_ANSWER",
              "RELATED_CHANGE"
            ]
          },
          "targetQuestionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "targetQuestionVersion": {
            "$ref": "#/$defs/opaqueVersion"
          },
          "operation": {
            "$ref": "#/$defs/operation"
          },
          "commitReference": {
            "$ref": "#/$defs/id"
          },
          "sensitive": {
            "type": "boolean"
          }
        }
      },
      "rejectedChange": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "targetQuestionKey",
          "reasonCode"
        ],
        "properties": {
          "targetQuestionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "reasonCode": {
            "type": "string",
            "enum": [
              "MODEL_EVIDENCE_UNSUPPORTED",
              "MODEL_IDENTIFIER_NOT_ALLOWED",
              "MODEL_VALUE_TYPE_INVALID",
              "MODEL_CONFLICTING_DECISION",
              "MODEL_HIGH_RISK_CERTAINTY_INSUFFICIENT",
              "STALE_QUESTION_VERSION",
              "CORRECTION_TARGET_AMBIGUOUS",
              "UNSUPPORTED_FORMAT"
            ]
          }
        }
      },
      "sideResult": {
        "oneOf": [
          {
            "$ref": "#/$defs/groundedAnswerSideResult"
          },
          {
            "$ref": "#/$defs/groundedNoAnswerSideResult"
          },
          {
            "$ref": "#/$defs/sessionTruthSideResult"
          },
          {
            "$ref": "#/$defs/deferredTaskSideResult"
          },
          {
            "$ref": "#/$defs/pauseSideResult"
          },
          {
            "$ref": "#/$defs/restartAppliedSideResult"
          },
          {
            "$ref": "#/$defs/restartConfirmationSideResult"
          },
          {
            "$ref": "#/$defs/languageChangeSideResult"
          },
          {
            "$ref": "#/$defs/smallTalkSideResult"
          },
          {
            "$ref": "#/$defs/recruiterTimingClarificationSideResult"
          },
          {
            "$ref": "#/$defs/unsupportedSideResult"
          }
        ]
      },
      "groundedAnswerSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode",
          "groundedAnswer"
        ],
        "properties": {
          "kind": {
            "const": "GROUNDED_ANSWER"
          },
          "status": {
            "const": "ANSWERED"
          },
          "reasonCode": {
            "const": "RAG_ANSWER_GROUNDED"
          },
          "groundedAnswer": {
            "$ref": "grounded-answer.v1.schema.json"
          }
        }
      },
      "groundedNoAnswerSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "GROUNDED_ANSWER"
          },
          "status": {
            "type": "string",
            "enum": [
              "REJECTED",
              "FAILED"
            ]
          },
          "reasonCode": {
            "const": "RAG_NO_ANSWER"
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "sessionTruthSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "SESSION_TRUTH"
          },
          "status": {
            "const": "ANSWERED"
          },
          "reasonCode": {
            "type": "string",
            "enum": [
              "SESSION_TRUTH_ANSWERED",
              "QUESTION_HELP_PURPOSE_ANSWERED",
              "QUESTION_HELP_TERM_ANSWERED"
            ]
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "deferredTaskSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "DEFERRED_TASK"
          },
          "status": {
            "type": "string",
            "enum": [
              "ANSWERED",
              "PENDING",
              "DEFERRED",
              "FAILED"
            ]
          },
          "reasonCode": {
            "type": "string",
            "enum": [
              "SIDE_QUESTION_PENDING",
              "BACKGROUND_WORK_ACKNOWLEDGED",
              "BACKGROUND_WORK_COMPLETED",
              "TURN_REQUIRES_REVIEW"
            ]
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "pauseSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "PAUSE"
          },
          "status": {
            "const": "APPLIED"
          },
          "reasonCode": {
            "const": "CONVERSATION_PAUSED"
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "restartAppliedSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "RESTART"
          },
          "status": {
            "const": "APPLIED"
          },
          "reasonCode": {
            "const": "CONVERSATION_RESTARTED"
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "restartConfirmationSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "RESTART"
          },
          "status": {
            "const": "CLARIFICATION_REQUIRED"
          },
          "reasonCode": {
            "const": "RESTART_CONFIRMATION_REQUIRED"
          }
        }
      },
      "languageChangeSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode",
          "targetLanguage"
        ],
        "properties": {
          "kind": {
            "const": "LANGUAGE_CHANGE"
          },
          "status": {
            "const": "APPLIED"
          },
          "reasonCode": {
            "const": "LANGUAGE_CHANGED"
          },
          "targetLanguage": {
            "$ref": "#/$defs/language"
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "smallTalkSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "SMALL_TALK"
          },
          "status": {
            "const": "ANSWERED"
          },
          "reasonCode": {
            "const": "SMALL_TALK_ACKNOWLEDGED"
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "recruiterTimingClarificationSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "RECRUITER_TIMING_CLARIFICATION"
          },
          "status": {
            "const": "CLARIFICATION_REQUIRED"
          },
          "reasonCode": {
            "const": "RECRUITER_TIMING_CLARIFICATION"
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "unsupportedSideResult": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "status",
          "reasonCode"
        ],
        "properties": {
          "kind": {
            "const": "UNSUPPORTED"
          },
          "status": {
            "type": "string",
            "enum": [
              "REJECTED",
              "FAILED"
            ]
          },
          "reasonCode": {
            "type": "string",
            "enum": [
              "UNSUPPORTED_FORMAT",
              "QUESTION_HELP_CLARIFICATION",
              "TURN_REQUIRES_REVIEW"
            ]
          },
          "body": {
            "$ref": "#/$defs/backendAuthoredBody"
          }
        }
      },
      "backendAuthoredBody": {
        "type": "string",
        "minLength": 1,
        "maxLength": 2000,
        "description": "Candidate-safe text selected or produced by an authoritative backend path, never model-authored decision prose."
      },
      "language": {
        "type": "string",
        "minLength": 2,
        "maxLength": 16,
        "pattern": "^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$"
      },
      "questionPresentation": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "questionId",
          "questionVersion",
          "body",
          "required",
          "options"
        ],
        "properties": {
          "questionId": {
            "$ref": "#/$defs/id"
          },
          "questionVersion": {
            "$ref": "#/$defs/opaqueVersion"
          },
          "body": {
            "type": "string",
            "minLength": 1,
            "maxLength": 1000
          },
          "required": {
            "type": "boolean"
          },
          "options": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "id",
                "label"
              ],
              "properties": {
                "id": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 120
                },
                "label": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 240
                }
              }
            }
          }
        }
      }
    }
  },
  "compose-request.v3.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/compose-request.v3.schema.json",
    "title": "ComposeRequestV3",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "language",
      "remainingDeadlineMs",
      "gate",
      "grounding",
      "plan"
    ],
    "description": "Everything the model may say is grounded here. The backend has already decided WHAT this reply conveys (the segments, the question, the option keys); Compose decides only HOW it is worded in the session language.",
    "properties": {
      "schemaVersion": {
        "const": "compose-request.v3"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "language": {
        "$ref": "turn-decision.v2.schema.json#/$defs/language"
      },
      "remainingDeadlineMs": {
        "type": "integer",
        "minimum": 0,
        "maximum": 60000
      },
      "gate": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "critic"
        ],
        "description": "Pre-send gate the caller requires before a reply may be returned as SUCCESS. The deterministic validators always run; `critic` additionally requires a second, independent model verdict.",
        "properties": {
          "critic": {
            "type": "boolean"
          }
        }
      },
      "grounding": {
        "$ref": "#/$defs/grounding"
      },
      "plan": {
        "oneOf": [
          {
            "$ref": "turn-plan.v3.schema.json"
          },
          {
            "type": "null"
          }
        ],
        "description": "The steer plan when this turn was steered rather than committed; context for the wording only, never a source of facts."
      },
      "conversation": {
        "oneOf": [
          {
            "$ref": "#/$defs/conversation"
          },
          {
            "type": "null"
          }
        ],
        "description": "OPTIONAL. The candidate's own words for this turn and a short recent window, so the writer can acknowledge what they actually said before repeating the question. Untrusted candidate content, never a source of facts, keys, or instructions."
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "segmentKind": {
        "type": "string",
        "enum": [
          "INTRO",
          "ACKNOWLEDGEMENT",
          "DOCUMENT_ACKNOWLEDGEMENT",
          "REPAIR",
          "CLARIFY",
          "SMALL_TALK_REDIRECT",
          "INFORMATION",
          "HANDOFF",
          "CONTROL",
          "RESUME",
          "COMPLETED",
          "GATE",
          "ERROR"
        ]
      },
      "segment": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "text",
          "verbatim"
        ],
        "description": "One fact the reply must convey, with the reviewed copy the backend would otherwise have sent as the grounding for it.",
        "properties": {
          "kind": {
            "$ref": "#/$defs/segmentKind"
          },
          "text": {
            "type": "string",
            "minLength": 1,
            "maxLength": 2000
          },
          "verbatim": {
            "type": "boolean",
            "description": "True when the text carries facts the model may not paraphrase (a grounded knowledge answer, session truth). The validator requires the exact text to appear in the reply."
          }
        }
      },
      "option": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "label"
        ],
        "properties": {
          "key": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "label": {
            "type": "string",
            "minLength": 1,
            "maxLength": 240
          }
        }
      },
      "question": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fieldKey",
          "text",
          "required",
          "options",
          "optionsPresentation"
        ],
        "properties": {
          "fieldKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "text": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4096
          },
          "required": {
            "type": "boolean"
          },
          "options": {
            "oneOf": [
              {
                "type": "array",
                "minItems": 1,
                "maxItems": 100,
                "items": {
                  "$ref": "#/$defs/option"
                }
              },
              {
                "type": "null"
              }
            ]
          },
          "optionsPresentation": {
            "type": "string",
            "enum": [
              "NONE",
              "INLINE",
              "CONTROL"
            ],
            "description": "NONE: no options. INLINE: the backend appends the numbered option list after the body, so the body must not list them. CONTROL: the channel renders the options as an interactive control under the body."
          }
        }
      },
      "grounding": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "segments",
          "question"
        ],
        "properties": {
          "segments": {
            "type": "array",
            "minItems": 0,
            "maxItems": 8,
            "items": {
              "$ref": "#/$defs/segment"
            }
          },
          "question": {
            "oneOf": [
              {
                "$ref": "#/$defs/question"
              },
              {
                "type": "null"
              }
            ]
          }
        }
      },
      "conversationTurn": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "speaker",
          "text"
        ],
        "properties": {
          "speaker": {
            "type": "string",
            "enum": [
              "CANDIDATE",
              "ASSISTANT"
            ]
          },
          "text": {
            "type": "string",
            "minLength": 1,
            "maxLength": 400
          }
        }
      },
      "conversation": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "candidateMessage",
          "recentTurns"
        ],
        "properties": {
          "candidateMessage": {
            "type": "string",
            "minLength": 1,
            "maxLength": 600
          },
          "recentTurns": {
            "type": "array",
            "minItems": 0,
            "maxItems": 4,
            "items": {
              "$ref": "#/$defs/conversationTurn"
            }
          }
        }
      }
    }
  },
  "compose-verdict.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/compose-verdict.v1.schema.json",
    "title": "ComposeVerdictV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "verdict",
      "findings"
    ],
    "description": "The reply critic's pre-send verdict on a composed reply, judged against the same grounding the composer received. A FAIL sends the reviewed deterministic copy instead.",
    "properties": {
      "schemaVersion": {
        "const": "compose-verdict.v1"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "verdict": {
        "type": "string",
        "enum": [
          "PASS",
          "FAIL"
        ]
      },
      "findings": {
        "type": "array",
        "maxItems": 8,
        "uniqueItems": true,
        "items": {
          "type": "string",
          "enum": [
            "MISSING_FACT",
            "EXTRA_CLAIM",
            "QUESTION_MISSING",
            "QUESTION_CHANGED",
            "OPTIONS_MISREPRESENTED",
            "WRONG_LANGUAGE",
            "TONE",
            "UNSAFE"
          ]
        }
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "composed-reply.v3.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/composed-reply.v3.schema.json",
    "title": "ComposedReplyV3",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "body",
      "optionLabels"
    ],
    "description": "The candidate-facing wording of one reply. The model authors the body and, when the backend supplied options, a label per option key. The keys themselves come from the request and must be echoed in the same order; the schema gives the model nowhere to add, drop or reorder one.",
    "properties": {
      "schemaVersion": {
        "const": "composed-reply.v3"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "body": {
        "type": "string",
        "minLength": 1,
        "maxLength": 1500,
        "description": "The whole message in the requested language, including the question when one is asked. Bounded under the WhatsApp limit so an appended inline option list still fits."
      },
      "optionLabels": {
        "oneOf": [
          {
            "type": "array",
            "minItems": 1,
            "maxItems": 100,
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "key",
                "text"
              ],
              "properties": {
                "key": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 120
                },
                "text": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 80,
                  "description": "Deliberately tighter than a reviewed label (240): a voiced label is a short choice the candidate taps or types, and the channel's interactive rows allow 20 to 24 characters. A longer reviewed label is voiced shorter, never echoed."
                }
              }
            }
          },
          {
            "type": "null"
          }
        ]
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "conversation-context.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/conversation-context.v1.schema.json",
    "title": "ConversationContextV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion"
    ],
    "properties": {
      "schemaVersion": {
        "const": "conversation-context.v1"
      },
      "recruiterFollowUp": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "timing",
          "status",
          "sourceTurnId",
          "requestedAt",
          "updatedAt",
          "actor"
        ],
        "properties": {
          "timing": {
            "const": "AFTER_ONBOARDING"
          },
          "status": {
            "type": "string",
            "enum": [
              "PENDING",
              "HANDED_OFF",
              "FULFILLED",
              "CANCELLED"
            ]
          },
          "sourceTurnId": {
            "$ref": "#/$defs/id"
          },
          "requestedAt": {
            "$ref": "#/$defs/dateTime"
          },
          "updatedAt": {
            "$ref": "#/$defs/dateTime"
          },
          "actor": {
            "type": "string",
            "enum": [
              "CANDIDATE",
              "RECRUITER",
              "SYSTEM"
            ]
          }
        }
      },
      "recruiterTimingClarification": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "status",
          "sourceTurnId",
          "requestedAt",
          "resumeQuestionKey",
          "resumeQuestionVersion"
        ],
        "properties": {
          "status": {
            "const": "PENDING"
          },
          "sourceTurnId": {
            "$ref": "#/$defs/id"
          },
          "requestedAt": {
            "$ref": "#/$defs/dateTime"
          },
          "resumeQuestionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "resumeQuestionVersion": {
            "type": "string",
            "minLength": 1,
            "maxLength": 128
          }
        }
      },
      "pendingSideTask": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "taskRef",
          "kind",
          "status",
          "sourceTurnId",
          "createdAt",
          "updatedAt"
        ],
        "properties": {
          "taskRef": {
            "$ref": "#/$defs/id"
          },
          "kind": {
            "type": "string",
            "enum": [
              "GROUNDED_RAG",
              "DOCUMENT_EXTRACTION",
              "COMPLEX_AMBIGUITY"
            ]
          },
          "status": {
            "type": "string",
            "enum": [
              "PENDING",
              "COMPLETED",
              "FAILED",
              "SUPERSEDED"
            ]
          },
          "sourceTurnId": {
            "$ref": "#/$defs/id"
          },
          "createdAt": {
            "$ref": "#/$defs/dateTime"
          },
          "updatedAt": {
            "$ref": "#/$defs/dateTime"
          }
        }
      },
      "pauseRequest": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "status",
          "sourceTurnId",
          "requestedAt",
          "actor"
        ],
        "properties": {
          "status": {
            "type": "string",
            "enum": [
              "APPLIED",
              "RESUMED",
              "CANCELLED"
            ]
          },
          "sourceTurnId": {
            "$ref": "#/$defs/id"
          },
          "requestedAt": {
            "$ref": "#/$defs/dateTime"
          },
          "actor": {
            "type": "string",
            "enum": [
              "CANDIDATE",
              "RECRUITER",
              "SYSTEM"
            ]
          }
        }
      },
      "lastReplyKinds": {
        "type": "array",
        "minItems": 1,
        "maxItems": 6,
        "uniqueItems": true,
        "items": {
          "type": "string",
          "enum": [
            "ACK",
            "ANSWER",
            "CLARIFICATION",
            "HANDOFF",
            "QUESTION",
            "ERROR"
          ]
        }
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "dateTime": {
        "type": "string",
        "format": "date-time",
        "maxLength": 40
      }
    }
  },
  "grounded-answer.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/grounded-answer.v1.schema.json",
    "title": "GroundedAnswerV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "correlationId",
      "truthStatus",
      "body",
      "evidence",
      "authorized"
    ],
    "properties": {
      "schemaVersion": {
        "const": "grounded-answer.v1"
      },
      "correlationId": {
        "$ref": "#/$defs/id"
      },
      "truthStatus": {
        "type": "string",
        "enum": [
          "GROUNDED",
          "NO_ANSWER",
          "UNAUTHORIZED",
          "FAILED"
        ]
      },
      "body": {
        "type": "string",
        "maxLength": 2000
      },
      "evidence": {
        "type": "array",
        "maxItems": 5,
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "evidenceId",
            "excerpt"
          ],
          "properties": {
            "evidenceId": {
              "type": "string",
              "minLength": 8,
              "maxLength": 160,
              "pattern": "^(POLICY|FAQ|JOB|AUTHORIZED_DOCUMENT):[A-Za-z0-9][A-Za-z0-9._:-]*$"
            },
            "excerpt": {
              "type": "string",
              "minLength": 1,
              "maxLength": 400
            }
          }
        }
      },
      "authorized": {
        "type": "boolean"
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "lifecycle-event.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/lifecycle-event.v1.schema.json",
    "title": "ConversationLifecycleEventV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "eventId",
      "eventCursor",
      "eventType",
      "sessionId",
      "sessionVersion",
      "occurredAt",
      "payload"
    ],
    "properties": {
      "schemaVersion": {
        "const": "lifecycle-event.v1"
      },
      "eventId": {
        "$ref": "#/$defs/id"
      },
      "eventCursor": {
        "type": "integer",
        "minimum": 1,
        "maximum": 9007199254740991
      },
      "eventType": {
        "const": "conversation.turn.lifecycle.v1"
      },
      "sessionId": {
        "$ref": "#/$defs/id"
      },
      "sessionVersion": {
        "type": "integer",
        "minimum": 0,
        "maximum": 9007199254740991
      },
      "occurredAt": {
        "type": "string",
        "format": "date-time",
        "maxLength": 40
      },
      "payload": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "turnId",
          "phase",
          "visibleToCandidate"
        ],
        "properties": {
          "turnId": {
            "$ref": "#/$defs/id"
          },
          "inboundMessageId": {
            "$ref": "#/$defs/id"
          },
          "logicalMessageId": {
            "$ref": "#/$defs/id"
          },
          "phase": {
            "type": "string",
            "enum": [
              "RECEIVED",
              "QUEUED",
              "UNDERSTANDING",
              "STEERING",
              "COMPOSING",
              "VALIDATING",
              "WAITING_FOR_REVIEW",
              "PREPARING_REPLY",
              "SENDING",
              "SENT",
              "FAILED",
              "SUPERSEDED",
              "RECONCILED"
            ]
          },
          "visibleToCandidate": {
            "type": "boolean"
          },
          "reasonCode": {
            "type": "string",
            "minLength": 1,
            "maxLength": 80
          },
          "retryable": {
            "type": "boolean"
          }
        }
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "parse-route-request.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/parse-route-request.v1.schema.json",
    "title": "ParseRouteRequestV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "requestId",
      "turnId",
      "deadlineAt",
      "prompt",
      "outputSchemaVersion",
      "snapshot",
      "candidateMessage",
      "allowedRoutes"
    ],
    "properties": {
      "schemaVersion": {
        "const": "parse-route-request.v1"
      },
      "requestId": {
        "$ref": "#/$defs/id"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "deadlineAt": {
        "type": "string",
        "format": "date-time",
        "maxLength": 40
      },
      "prompt": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "version",
          "hash"
        ],
        "properties": {
          "id": {
            "type": "string",
            "minLength": 1,
            "maxLength": 80
          },
          "version": {
            "type": "string",
            "minLength": 1,
            "maxLength": 80
          },
          "hash": {
            "$ref": "#/$defs/hash"
          }
        }
      },
      "outputSchemaVersion": {
        "const": "turn-result.v1"
      },
      "snapshot": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "builderVersion",
          "builderHash",
          "sessionVersion",
          "questionVersion",
          "languagePolicy",
          "currentQuestion",
          "allowedRelatedQuestions",
          "recentMessages"
        ],
        "properties": {
          "builderVersion": {
            "type": "string",
            "minLength": 1,
            "maxLength": 80
          },
          "builderHash": {
            "$ref": "#/$defs/hash"
          },
          "sessionVersion": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          },
          "questionVersion": {
            "type": "integer",
            "minimum": 0,
            "maximum": 2147483647
          },
          "languagePolicy": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "sessionLanguage",
              "supportedLanguages",
              "dateOrder"
            ],
            "properties": {
              "sessionLanguage": {
                "$ref": "#/$defs/language"
              },
              "supportedLanguages": {
                "type": "array",
                "minItems": 1,
                "maxItems": 24,
                "uniqueItems": true,
                "items": {
                  "$ref": "#/$defs/language"
                }
              },
              "dateOrder": {
                "type": "string",
                "enum": [
                  "DMY",
                  "MDY",
                  "YMD"
                ]
              }
            }
          },
          "currentQuestion": {
            "$ref": "#/$defs/question"
          },
          "allowedRelatedQuestions": {
            "type": "array",
            "maxItems": 5,
            "items": {
              "$ref": "#/$defs/relatedQuestion"
            }
          },
          "recentMessages": {
            "type": "array",
            "maxItems": 8,
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "role",
                "text"
              ],
              "properties": {
                "role": {
                  "type": "string",
                  "enum": [
                    "CANDIDATE",
                    "ASSISTANT",
                    "RECRUITER"
                  ]
                },
                "text": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 1000
                }
              }
            }
          },
          "sessionSummary": {
            "type": "string",
            "maxLength": 1500
          }
        }
      },
      "candidateMessage": {
        "type": "string",
        "minLength": 1,
        "maxLength": 4000
      },
      "allowedRoutes": {
        "type": "array",
        "minItems": 1,
        "maxItems": 8,
        "uniqueItems": true,
        "items": {
          "$ref": "#/$defs/route"
        }
      },
      "traceparent": {
        "type": "string",
        "minLength": 55,
        "maxLength": 512
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "hash": {
        "type": "string",
        "pattern": "^[a-f0-9]{64}$"
      },
      "language": {
        "type": "string",
        "minLength": 2,
        "maxLength": 16,
        "pattern": "^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$"
      },
      "route": {
        "type": "string",
        "enum": [
          "ANSWER_CURRENT",
          "SIDE_QUESTION",
          "SESSION_QUESTION",
          "RECRUITER_REQUEST",
          "CORRECTION",
          "FILE_CONTEXT",
          "AMBIGUOUS",
          "UNSUPPORTED"
        ]
      },
      "answerType": {
        "type": "string",
        "enum": [
          "TEXT",
          "TEXTAREA",
          "NUMBER",
          "BOOLEAN",
          "RADIO",
          "MULTISELECT",
          "DATE",
          "EMAIL",
          "FILE",
          "LIST_OBJECT",
          "ACTION"
        ]
      },
      "option": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "label",
          "aliases"
        ],
        "properties": {
          "id": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "label": {
            "type": "string",
            "minLength": 1,
            "maxLength": 240
          },
          "aliases": {
            "type": "array",
            "maxItems": 12,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      },
      "question": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "questionKey",
          "version",
          "answerType",
          "required",
          "prompt",
          "options",
          "highRisk"
        ],
        "properties": {
          "questionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "version": {
            "type": "integer",
            "minimum": 0,
            "maximum": 2147483647
          },
          "answerType": {
            "$ref": "#/$defs/answerType"
          },
          "required": {
            "type": "boolean"
          },
          "prompt": {
            "type": "string",
            "minLength": 1,
            "maxLength": 1000
          },
          "options": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "$ref": "#/$defs/option"
            }
          },
          "highRisk": {
            "type": "boolean"
          },
          "validationHint": {
            "type": "string",
            "maxLength": 500
          }
        }
      },
      "relatedQuestion": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "questionKey",
          "version",
          "answerType",
          "allowedOperations",
          "highRisk"
        ],
        "properties": {
          "questionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "version": {
            "type": "integer",
            "minimum": 0,
            "maximum": 2147483647
          },
          "answerType": {
            "$ref": "#/$defs/answerType"
          },
          "allowedOperations": {
            "type": "array",
            "minItems": 1,
            "maxItems": 4,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "enum": [
                "SET",
                "ADD",
                "REMOVE",
                "CLEAR"
              ]
            }
          },
          "allowedOptionIds": {
            "type": "array",
            "maxItems": 100,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          },
          "highRisk": {
            "type": "boolean"
          }
        }
      }
    }
  },
  "parse-route-request.v2.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/parse-route-request.v2.schema.json",
    "title": "ParseRouteRequestV2",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "requestId",
      "outputSchemaVersion",
      "snapshot",
      "candidateInput",
      "extraInferenceReason"
    ],
    "properties": {
      "schemaVersion": {
        "const": "parse-route-request.v2"
      },
      "requestId": {
        "$ref": "#/$defs/id"
      },
      "outputSchemaVersion": {
        "const": "turn-decision.v2"
      },
      "snapshot": {
        "$ref": "turn-snapshot.v2.schema.json"
      },
      "candidateInput": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "trust",
          "text"
        ],
        "properties": {
          "trust": {
            "const": "UNTRUSTED_CANDIDATE_INPUT"
          },
          "text": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          }
        }
      },
      "extraInferenceReason": {
        "type": "string",
        "enum": [
          "NONE",
          "GROUNDED_RAG",
          "DOCUMENT_EXTRACTION",
          "COMPLEX_AMBIGUITY",
          "HUMAN_TAKEOVER"
        ]
      },
      "traceparent": {
        "type": "string",
        "minLength": 55,
        "maxLength": 512
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "parse-route-response.v2.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/parse-route-response.v2.schema.json",
    "title": "ParseRouteResponseV2",
    "oneOf": [
      {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "schemaVersion",
          "requestId",
          "outcome",
          "decision",
          "generation"
        ],
        "properties": {
          "schemaVersion": {
            "const": "parse-route-response.v2"
          },
          "requestId": {
            "$ref": "#/$defs/id"
          },
          "outcome": {
            "const": "SUCCESS"
          },
          "decision": {
            "$ref": "turn-decision.v2.schema.json"
          },
          "generation": {
            "$ref": "provider-generation.v1.schema.json"
          }
        }
      },
      {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "schemaVersion",
          "requestId",
          "outcome",
          "generation"
        ],
        "properties": {
          "schemaVersion": {
            "const": "parse-route-response.v2"
          },
          "requestId": {
            "$ref": "#/$defs/id"
          },
          "outcome": {
            "const": "ERROR"
          },
          "generation": {
            "$ref": "provider-generation.v1.schema.json"
          }
        }
      }
    ],
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      }
    }
  },
  "provider-error.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/provider-error.v1.schema.json",
    "title": "ProviderErrorV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "code",
      "retryable",
      "providerStatusCode",
      "category"
    ],
    "properties": {
      "schemaVersion": {
        "const": "provider-error.v1"
      },
      "code": {
        "type": "string",
        "enum": [
          "PROVIDER_TIMEOUT",
          "PROVIDER_CANCELLED",
          "PROVIDER_RATE_LIMIT",
          "PROVIDER_UNAVAILABLE",
          "PROVIDER_BAD_RESPONSE",
          "PROVIDER_UNSUPPORTED_SCHEMA",
          "PROVIDER_CONFIGURATION_INVALID",
          "PROVIDER_BUDGET_REJECTED",
          "MODEL_OUTPUT_EMPTY",
          "MODEL_REFUSAL",
          "MODEL_SCHEMA_INVALID",
          "MODEL_EVIDENCE_UNSUPPORTED",
          "MODEL_IDENTIFIER_NOT_ALLOWED",
          "MODEL_VALUE_TYPE_INVALID",
          "MODEL_ROUTE_NOT_ALLOWED",
          "MODEL_CONFLICTING_DECISION",
          "MODEL_HIGH_RISK_CERTAINTY_INSUFFICIENT",
          "MODEL_CRITIC_REJECTED",
          "GATE_PROVIDER_UNAVAILABLE"
        ]
      },
      "retryable": {
        "type": "boolean"
      },
      "providerStatusCode": {
        "type": [
          "integer",
          "null"
        ],
        "minimum": 100,
        "maximum": 599
      },
      "category": {
        "type": "string",
        "enum": [
          "TIMEOUT",
          "CANCELLED",
          "RATE_LIMIT",
          "AVAILABILITY",
          "REFUSAL",
          "EMPTY",
          "TRUNCATION",
          "SCHEMA",
          "SEMANTIC",
          "CONFIGURATION",
          "BUDGET",
          "UNKNOWN"
        ]
      }
    }
  },
  "provider-generation.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/provider-generation.v1.schema.json",
    "title": "ProviderGenerationV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "generationId",
      "requestId",
      "provider",
      "model",
      "sdk",
      "prompt",
      "outputSchema",
      "context",
      "parameters",
      "usage",
      "startedAt",
      "completedAt",
      "latencyMs",
      "attemptCount",
      "hiddenRetriesDisabled",
      "extraInferenceReason",
      "outcome",
      "error"
    ],
    "properties": {
      "schemaVersion": {
        "const": "provider-generation.v1"
      },
      "generationId": {
        "$ref": "#/$defs/id"
      },
      "requestId": {
        "$ref": "#/$defs/id"
      },
      "clientRequestId": {
        "$ref": "#/$defs/id"
      },
      "providerRequestId": {
        "type": [
          "string",
          "null"
        ],
        "minLength": 1,
        "maxLength": 240
      },
      "provider": {
        "$ref": "#/$defs/releaseId"
      },
      "model": {
        "$ref": "#/$defs/releaseId"
      },
      "resolvedModel": {
        "type": [
          "string",
          "null"
        ],
        "minLength": 1,
        "maxLength": 120,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"
      },
      "finishReason": {
        "type": [
          "string",
          "null"
        ],
        "minLength": 1,
        "maxLength": 80,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"
      },
      "sdk": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "name",
          "version"
        ],
        "properties": {
          "name": {
            "$ref": "#/$defs/releaseId"
          },
          "version": {
            "$ref": "#/$defs/releaseId"
          }
        }
      },
      "prompt": {
        "$ref": "#/$defs/release"
      },
      "outputSchema": {
        "$ref": "#/$defs/release"
      },
      "context": {
        "$ref": "#/$defs/release"
      },
      "parameters": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "temperature",
          "topP",
          "topK",
          "maxOutputTokens",
          "reasoningBudgetTokens",
          "reasoningEffort",
          "timeoutMs",
          "seed",
          "candidateCount"
        ],
        "properties": {
          "temperature": {
            "type": [
              "number",
              "null"
            ],
            "minimum": 0,
            "maximum": 2
          },
          "topP": {
            "type": [
              "number",
              "null"
            ],
            "minimum": 0,
            "maximum": 1
          },
          "topK": {
            "type": [
              "integer",
              "null"
            ],
            "minimum": 1,
            "maximum": 1000
          },
          "maxOutputTokens": {
            "type": "integer",
            "minimum": 1,
            "maximum": 65536
          },
          "reasoningBudgetTokens": {
            "type": [
              "integer",
              "null"
            ],
            "minimum": 0,
            "maximum": 65536
          },
          "reasoningEffort": {
            "type": "string",
            "enum": [
              "NONE",
              "MINIMAL",
              "LOW",
              "MEDIUM",
              "HIGH"
            ]
          },
          "timeoutMs": {
            "type": "integer",
            "minimum": 1,
            "maximum": 300000
          },
          "seed": {
            "type": [
              "integer",
              "null"
            ],
            "minimum": 0,
            "maximum": 4294967295
          },
          "candidateCount": {
            "const": 1
          }
        }
      },
      "usage": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "reported",
          "inputTokens",
          "outputTokens",
          "cachedInputTokens",
          "reasoningTokens",
          "totalTokens"
        ],
        "properties": {
          "reported": {
            "type": "boolean"
          },
          "inputTokens": {
            "$ref": "#/$defs/nullableCount"
          },
          "outputTokens": {
            "$ref": "#/$defs/nullableCount"
          },
          "cachedInputTokens": {
            "$ref": "#/$defs/nullableCount"
          },
          "cacheWriteTokens": {
            "$ref": "#/$defs/nullableCount"
          },
          "reasoningTokens": {
            "$ref": "#/$defs/nullableCount"
          },
          "totalTokens": {
            "$ref": "#/$defs/nullableCount"
          }
        }
      },
      "startedAt": {
        "$ref": "#/$defs/dateTime"
      },
      "completedAt": {
        "$ref": "#/$defs/dateTime"
      },
      "latencyMs": {
        "type": "integer",
        "minimum": 0,
        "maximum": 300000
      },
      "attemptCount": {
        "type": "integer",
        "minimum": 0,
        "maximum": 10
      },
      "hiddenRetriesDisabled": {
        "type": "boolean"
      },
      "extraInferenceReason": {
        "type": "string",
        "enum": [
          "NONE",
          "GROUNDED_RAG",
          "DOCUMENT_EXTRACTION",
          "COMPLEX_AMBIGUITY",
          "HUMAN_TAKEOVER"
        ]
      },
      "outcome": {
        "type": "string",
        "enum": [
          "SUCCESS",
          "REFUSAL",
          "EMPTY",
          "TRUNCATED",
          "SCHEMA_INVALID",
          "SEMANTIC_INVALID",
          "TIMEOUT",
          "CANCELLED",
          "RATE_LIMIT",
          "UNAVAILABLE",
          "BAD_RESPONSE",
          "UNSUPPORTED_SCHEMA",
          "CONFIGURATION_INVALID",
          "BUDGET_REJECTED"
        ]
      },
      "error": {
        "oneOf": [
          {
            "$ref": "provider-error.v1.schema.json"
          },
          {
            "type": "null"
          }
        ]
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "releaseId": {
        "type": "string",
        "minLength": 1,
        "maxLength": 120,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:/-]*$"
      },
      "hash": {
        "type": "string",
        "pattern": "^[a-f0-9]{64}$"
      },
      "dateTime": {
        "type": "string",
        "format": "date-time",
        "maxLength": 40
      },
      "nullableCount": {
        "type": [
          "integer",
          "null"
        ],
        "minimum": 0,
        "maximum": 9007199254740991
      },
      "release": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "version",
          "hash"
        ],
        "properties": {
          "id": {
            "$ref": "#/$defs/releaseId"
          },
          "version": {
            "$ref": "#/$defs/releaseId"
          },
          "hash": {
            "$ref": "#/$defs/hash"
          }
        }
      }
    }
  },
  "steer-request.v3.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/steer-request.v3.schema.json",
    "title": "SteerRequestV3",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "checklist",
      "unvoicedCommits",
      "unresolvedSideIntents",
      "healthSignals",
      "remainingDeadlineMs",
      "language",
      "understood",
      "currentFieldKey"
    ],
    "properties": {
      "schemaVersion": {
        "const": "steer-request.v3"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "checklist": {
        "$ref": "checklist-state.v1.schema.json"
      },
      "unvoicedCommits": {
        "type": "array",
        "maxItems": 20,
        "items": {
          "$ref": "understand-request.v3.schema.json#/$defs/unvoicedCommit"
        }
      },
      "unresolvedSideIntents": {
        "type": "array",
        "maxItems": 2,
        "uniqueItems": true,
        "items": {
          "$ref": "turn-decision.v2.schema.json#/properties/sideIntents/items"
        }
      },
      "healthSignals": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "consecutiveInvalidParses",
          "turnsSinceProgress",
          "clarifyCount"
        ],
        "properties": {
          "consecutiveInvalidParses": {
            "type": "integer",
            "minimum": 0
          },
          "turnsSinceProgress": {
            "type": "integer",
            "minimum": 0
          },
          "clarifyCount": {
            "type": "integer",
            "minimum": 0
          }
        }
      },
      "remainingDeadlineMs": {
        "type": "integer",
        "minimum": 0,
        "maximum": 60000
      },
      "language": {
        "$ref": "turn-decision.v2.schema.json#/$defs/language"
      },
      "understood": {
        "$ref": "#/$defs/understoodDigest"
      },
      "currentFieldKey": {
        "type": "string",
        "minLength": 1,
        "maxLength": 120
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "understoodDigest": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "proposals",
          "detectedLanguage"
        ],
        "properties": {
          "proposals": {
            "type": "array",
            "maxItems": 8,
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "fieldKey",
                "operation",
                "certainty"
              ],
              "properties": {
                "fieldKey": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 120
                },
                "operation": {
                  "$ref": "understand-result.v3.schema.json#/$defs/proposal/properties/operation"
                },
                "certainty": {
                  "$ref": "turn-decision.v2.schema.json#/$defs/certainty"
                }
              }
            }
          },
          "detectedLanguage": {
            "$ref": "turn-decision.v2.schema.json#/$defs/language"
          }
        }
      }
    }
  },
  "turn-decision.v2.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/turn-decision.v2.schema.json",
    "title": "TurnDecisionV2",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "route",
      "detectedLanguage",
      "currentAnswer",
      "relatedChanges",
      "sideIntents",
      "clarification",
      "safety"
    ],
    "properties": {
      "schemaVersion": {
        "const": "turn-decision.v2"
      },
      "route": {
        "$ref": "#/$defs/route"
      },
      "detectedLanguage": {
        "$ref": "#/$defs/language"
      },
      "currentAnswer": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "status",
          "value",
          "evidence",
          "certainty"
        ],
        "properties": {
          "status": {
            "type": "string",
            "enum": [
              "VALID",
              "INVALID",
              "AMBIGUOUS",
              "NOT_ANSWERED"
            ]
          },
          "value": {
            "$ref": "#/$defs/nullableTypedValue"
          },
          "evidence": {
            "$ref": "#/$defs/evidence"
          },
          "certainty": {
            "$ref": "#/$defs/certainty"
          }
        }
      },
      "relatedChanges": {
        "type": "array",
        "maxItems": 3,
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "targetQuestionKey",
            "targetQuestionVersion",
            "operation",
            "value",
            "evidence",
            "certainty"
          ],
          "properties": {
            "targetQuestionKey": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            },
            "targetQuestionVersion": {
              "$ref": "#/$defs/opaqueVersion"
            },
            "operation": {
              "$ref": "#/$defs/operation"
            },
            "value": {
              "$ref": "#/$defs/nullableTypedValue"
            },
            "evidence": {
              "$ref": "#/$defs/requiredEvidence"
            },
            "certainty": {
              "type": "string",
              "enum": [
                "EXPLICIT",
                "STRONG"
              ]
            }
          }
        }
      },
      "sideIntents": {
        "type": "array",
        "maxItems": 2,
        "uniqueItems": true,
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "kind",
            "evidence"
          ],
          "properties": {
            "kind": {
              "type": "string",
              "enum": [
                "KNOWLEDGE",
                "SESSION_TRUTH",
                "QUESTION_HELP",
                "RECRUITER",
                "PAUSE",
                "RESTART",
                "LANGUAGE_CHANGE",
                "SMALL_TALK"
              ]
            },
            "timing": {
              "type": "string",
              "enum": [
                "NOW",
                "AFTER_ONBOARDING"
              ]
            },
            "query": {
              "type": "string",
              "minLength": 1,
              "maxLength": 1000
            },
            "targetLanguage": {
              "$ref": "#/$defs/language"
            },
            "mode": {
              "type": "string",
              "enum": [
                "PURPOSE",
                "TERM"
              ]
            },
            "optionId": {
              "type": [
                "string",
                "null"
              ],
              "minLength": 1,
              "maxLength": 120
            },
            "evidence": {
              "$ref": "#/$defs/requiredEvidence"
            }
          },
          "allOf": [
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "QUESTION_HELP"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "required": [
                  "mode",
                  "optionId"
                ],
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "timing"
                      ]
                    },
                    {
                      "required": [
                        "query"
                      ]
                    },
                    {
                      "required": [
                        "targetLanguage"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "KNOWLEDGE"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "SESSION_TRUTH"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "RECRUITER"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "PAUSE"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "RESTART"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "LANGUAGE_CHANGE"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            },
            {
              "if": {
                "properties": {
                  "kind": {
                    "const": "SMALL_TALK"
                  }
                },
                "required": [
                  "kind"
                ]
              },
              "then": {
                "not": {
                  "anyOf": [
                    {
                      "required": [
                        "mode"
                      ]
                    },
                    {
                      "required": [
                        "optionId"
                      ]
                    }
                  ]
                }
              }
            }
          ]
        }
      },
      "clarification": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "reasonCode",
          "focus",
          "canonicalOptionIds"
        ],
        "properties": {
          "reasonCode": {
            "type": "string",
            "enum": [
              "NONE",
              "MISSING_REQUIRED_VALUE",
              "CONFLICTING_EXPLICIT_VALUES",
              "OUT_OF_RANGE",
              "UNKNOWN_OPTION",
              "MULTIPLE_INTERPRETATIONS",
              "UNSUPPORTED_FORMAT",
              "RECRUITER_TIMING_AMBIGUOUS",
              "CORRECTION_TARGET_AMBIGUOUS"
            ]
          },
          "focus": {
            "type": "string",
            "maxLength": 160
          },
          "canonicalOptionIds": {
            "type": "array",
            "maxItems": 10,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      },
      "safety": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "promptInjectionSuspected",
          "sensitiveDataPresent",
          "requiresHumanReview",
          "reasonCode"
        ],
        "properties": {
          "promptInjectionSuspected": {
            "type": "boolean"
          },
          "sensitiveDataPresent": {
            "type": "boolean"
          },
          "requiresHumanReview": {
            "type": "boolean"
          },
          "reasonCode": {
            "type": "string",
            "enum": [
              "NONE",
              "SENSITIVE_CONFLICT",
              "HEALTH_RISK",
              "ABUSE",
              "PROMPT_INJECTION",
              "HIGH_RISK_VERIFICATION_REQUIRED",
              "UNKNOWN"
            ]
          }
        }
      }
    },
    "$defs": {
      "opaqueVersion": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128
      },
      "language": {
        "type": "string",
        "minLength": 2,
        "maxLength": 16,
        "pattern": "^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$"
      },
      "route": {
        "type": "string",
        "enum": [
          "ANSWER_CURRENT",
          "CORRECTION",
          "SIDE_QUESTION",
          "SESSION_QUESTION",
          "RECRUITER_REQUEST",
          "SKIP",
          "AMBIGUOUS",
          "UNSUPPORTED"
        ]
      },
      "operation": {
        "type": "string",
        "enum": [
          "SET",
          "ADD",
          "REMOVE",
          "CLEAR"
        ]
      },
      "certainty": {
        "type": "string",
        "enum": [
          "EXPLICIT",
          "STRONG",
          "WEAK"
        ]
      },
      "evidence": {
        "type": "array",
        "maxItems": 4,
        "items": {
          "type": "string",
          "minLength": 1,
          "maxLength": 240
        }
      },
      "requiredEvidence": {
        "type": "array",
        "minItems": 1,
        "maxItems": 4,
        "items": {
          "type": "string",
          "minLength": 1,
          "maxLength": 240
        }
      },
      "scalar": {
        "type": [
          "string",
          "number",
          "boolean",
          "null"
        ],
        "maxLength": 4000
      },
      "objectField": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "value"
        ],
        "properties": {
          "key": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "value": {
            "$ref": "#/$defs/scalar"
          }
        }
      },
      "listObject": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fields"
        ],
        "properties": {
          "fields": {
            "type": "array",
            "minItems": 1,
            "maxItems": 20,
            "items": {
              "$ref": "#/$defs/objectField"
            }
          }
        }
      },
      "typedValue": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "scalar",
          "items",
          "objects"
        ],
        "properties": {
          "kind": {
            "type": "string",
            "enum": [
              "SCALAR",
              "LIST",
              "OBJECT_LIST"
            ]
          },
          "scalar": {
            "$ref": "#/$defs/scalar"
          },
          "items": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "$ref": "#/$defs/scalar"
            }
          },
          "objects": {
            "type": "array",
            "maxItems": 10,
            "items": {
              "$ref": "#/$defs/listObject"
            }
          }
        }
      },
      "nullableTypedValue": {
        "type": [
          "object",
          "null"
        ],
        "additionalProperties": false,
        "required": [
          "kind",
          "scalar",
          "items",
          "objects"
        ],
        "properties": {
          "kind": {
            "type": "string",
            "enum": [
              "SCALAR",
              "LIST",
              "OBJECT_LIST"
            ]
          },
          "scalar": {
            "$ref": "#/$defs/scalar"
          },
          "items": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "$ref": "#/$defs/scalar"
            }
          },
          "objects": {
            "type": "array",
            "maxItems": 10,
            "items": {
              "$ref": "#/$defs/listObject"
            }
          }
        }
      }
    }
  },
  "turn-plan.v3.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/turn-plan.v3.schema.json",
    "title": "TurnPlanV3",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "primaryMove",
      "secondaryAcknowledgements",
      "rationale"
    ],
    "properties": {
      "schemaVersion": {
        "const": "turn-plan.v3"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "primaryMove": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "move",
          "targetFieldKeys",
          "wantsPresentation"
        ],
        "properties": {
          "move": {
            "$ref": "#/$defs/move"
          },
          "targetFieldKeys": {
            "type": "array",
            "maxItems": 2,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          },
          "wantsPresentation": {
            "type": "boolean"
          }
        }
      },
      "secondaryAcknowledgements": {
        "type": "array",
        "maxItems": 5,
        "items": {
          "$ref": "#/$defs/secondaryAcknowledgement"
        }
      },
      "rationale": {
        "type": "string",
        "minLength": 1,
        "maxLength": 600
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "move": {
        "type": "string",
        "enum": [
          "ASK_FIELD",
          "CLARIFY",
          "SMALL_TALK_REDIRECT"
        ]
      },
      "secondaryAcknowledgement": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "kind",
          "fieldKey"
        ],
        "properties": {
          "kind": {
            "type": "string",
            "enum": [
              "UNVOICED_COMMIT",
              "LANE_PENDING",
              "SMALL_TALK"
            ]
          },
          "fieldKey": {
            "type": [
              "string",
              "null"
            ],
            "minLength": 1,
            "maxLength": 120
          }
        }
      }
    }
  },
  "turn-result.v1.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/turn-result.v1.schema.json",
    "title": "TurnResultV1",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "route",
      "detectedLanguage",
      "currentAnswer",
      "relatedChanges",
      "sideIntent",
      "clarification",
      "safety"
    ],
    "properties": {
      "schemaVersion": {
        "const": "turn-result.v1"
      },
      "route": {
        "$ref": "#/$defs/route"
      },
      "detectedLanguage": {
        "type": "string",
        "minLength": 2,
        "maxLength": 16,
        "pattern": "^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$"
      },
      "currentAnswer": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "status",
          "value",
          "evidence",
          "certainty"
        ],
        "properties": {
          "status": {
            "type": "string",
            "enum": [
              "VALID",
              "INVALID",
              "AMBIGUOUS",
              "NOT_ANSWERED"
            ]
          },
          "value": {
            "$ref": "#/$defs/typedValue"
          },
          "evidence": {
            "$ref": "#/$defs/evidence"
          },
          "certainty": {
            "$ref": "#/$defs/certainty"
          }
        }
      },
      "relatedChanges": {
        "type": "array",
        "maxItems": 5,
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "questionKey",
            "questionVersion",
            "operation",
            "value",
            "evidence",
            "certainty"
          ],
          "properties": {
            "questionKey": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            },
            "questionVersion": {
              "type": "integer",
              "minimum": 0,
              "maximum": 2147483647
            },
            "operation": {
              "type": "string",
              "enum": [
                "SET",
                "ADD",
                "REMOVE",
                "CLEAR"
              ]
            },
            "value": {
              "$ref": "#/$defs/typedValue"
            },
            "evidence": {
              "type": "array",
              "minItems": 1,
              "maxItems": 4,
              "items": {
                "type": "string",
                "minLength": 1,
                "maxLength": 240
              }
            },
            "certainty": {
              "$ref": "#/$defs/certainty"
            }
          }
        }
      },
      "sideIntent": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "type",
          "query",
          "evidence"
        ],
        "properties": {
          "type": {
            "type": "string",
            "enum": [
              "NONE",
              "KNOWLEDGE",
              "STATUS",
              "RECRUITER",
              "HEALTH_OR_FRUSTRATION",
              "RESTART"
            ]
          },
          "query": {
            "type": "string",
            "maxLength": 1000
          },
          "evidence": {
            "$ref": "#/$defs/evidence"
          }
        }
      },
      "clarification": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "reasonCode",
          "focus",
          "candidateOptionIds"
        ],
        "properties": {
          "reasonCode": {
            "type": "string",
            "enum": [
              "NONE",
              "MISSING",
              "CONFLICTING",
              "OUT_OF_RANGE",
              "UNKNOWN_OPTION",
              "MULTIPLE_INTERPRETATIONS",
              "UNSUPPORTED_FORMAT"
            ]
          },
          "focus": {
            "type": "string",
            "maxLength": 300
          },
          "candidateOptionIds": {
            "type": "array",
            "maxItems": 10,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      },
      "safety": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "requiresHuman",
          "reasonCode"
        ],
        "properties": {
          "requiresHuman": {
            "type": "boolean"
          },
          "reasonCode": {
            "type": "string",
            "enum": [
              "NONE",
              "SENSITIVE_CONFLICT",
              "HEALTH_RISK",
              "ABUSE",
              "PROMPT_INJECTION",
              "UNKNOWN"
            ]
          }
        }
      }
    },
    "$defs": {
      "route": {
        "type": "string",
        "enum": [
          "ANSWER_CURRENT",
          "SIDE_QUESTION",
          "SESSION_QUESTION",
          "RECRUITER_REQUEST",
          "CORRECTION",
          "FILE_CONTEXT",
          "AMBIGUOUS",
          "UNSUPPORTED"
        ]
      },
      "certainty": {
        "type": "string",
        "enum": [
          "EXPLICIT",
          "STRONG",
          "WEAK"
        ]
      },
      "evidence": {
        "type": "array",
        "maxItems": 4,
        "items": {
          "type": "string",
          "minLength": 1,
          "maxLength": 240
        }
      },
      "scalar": {
        "type": [
          "string",
          "number",
          "boolean",
          "null"
        ],
        "maxLength": 4000
      },
      "objectField": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "value"
        ],
        "properties": {
          "key": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "value": {
            "$ref": "#/$defs/scalar"
          }
        }
      },
      "listObject": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fields"
        ],
        "properties": {
          "fields": {
            "type": "array",
            "minItems": 1,
            "maxItems": 20,
            "items": {
              "$ref": "#/$defs/objectField"
            }
          }
        }
      },
      "typedValue": {
        "oneOf": [
          {
            "$ref": "#/$defs/scalar"
          },
          {
            "type": "array",
            "maxItems": 100,
            "items": {
              "$ref": "#/$defs/scalar"
            }
          },
          {
            "type": "array",
            "maxItems": 10,
            "items": {
              "$ref": "#/$defs/listObject"
            }
          }
        ]
      }
    }
  },
  "turn-snapshot.v2.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/turn-snapshot.v2.schema.json",
    "title": "TurnSnapshotV2",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "sessionId",
      "sessionVersion",
      "stateVersion",
      "questionVersion",
      "takeoverEpoch",
      "deadlineAt",
      "totalDeadlineMs",
      "languagePolicy",
      "currentQuestion",
      "eligibleRelatedTargets",
      "recentMessagesQueryLimit",
      "recentMessages",
      "progressFacts",
      "conversationContext",
      "allowedRoutes",
      "policy",
      "release"
    ],
    "properties": {
      "schemaVersion": {
        "const": "turn-snapshot.v2"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "sessionId": {
        "$ref": "#/$defs/id"
      },
      "sessionVersion": {
        "$ref": "#/$defs/opaqueVersion"
      },
      "stateVersion": {
        "$ref": "#/$defs/opaqueVersion"
      },
      "questionVersion": {
        "$ref": "#/$defs/opaqueVersion"
      },
      "takeoverEpoch": {
        "$ref": "#/$defs/opaqueVersion"
      },
      "deadlineAt": {
        "type": "string",
        "format": "date-time",
        "maxLength": 40
      },
      "totalDeadlineMs": {
        "type": "integer",
        "minimum": 100,
        "maximum": 10000
      },
      "languagePolicy": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "sessionLanguage",
          "supportedLanguages",
          "dateOrder"
        ],
        "properties": {
          "sessionLanguage": {
            "$ref": "#/$defs/language"
          },
          "supportedLanguages": {
            "type": "array",
            "minItems": 1,
            "maxItems": 24,
            "uniqueItems": true,
            "items": {
              "$ref": "#/$defs/language"
            }
          },
          "dateOrder": {
            "type": "string",
            "enum": [
              "DMY",
              "MDY",
              "YMD"
            ]
          }
        }
      },
      "currentQuestion": {
        "$ref": "#/$defs/question"
      },
      "eligibleRelatedTargets": {
        "type": "array",
        "maxItems": 5,
        "items": {
          "$ref": "#/$defs/relatedTarget"
        }
      },
      "recentMessagesQueryLimit": {
        "const": 6
      },
      "recentMessages": {
        "type": "array",
        "maxItems": 6,
        "items": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "role",
            "text"
          ],
          "properties": {
            "role": {
              "type": "string",
              "enum": [
                "CANDIDATE",
                "ASSISTANT",
                "RECRUITER"
              ]
            },
            "text": {
              "type": "string",
              "minLength": 1,
              "maxLength": 400
            }
          }
        }
      },
      "progressFacts": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "stage",
          "answeredRequiredCount",
          "totalRequiredCount",
          "aiPaused",
          "recruiterFollowUpPending",
          "sideTaskPending"
        ],
        "properties": {
          "stage": {
            "type": "string",
            "minLength": 1,
            "maxLength": 80
          },
          "answeredRequiredCount": {
            "type": "integer",
            "minimum": 0,
            "maximum": 10000
          },
          "totalRequiredCount": {
            "type": "integer",
            "minimum": 0,
            "maximum": 10000
          },
          "approximateRemainingCount": {
            "type": "integer",
            "minimum": 0,
            "maximum": 10000
          },
          "aiPaused": {
            "type": "boolean"
          },
          "recruiterFollowUpPending": {
            "type": "boolean"
          },
          "sideTaskPending": {
            "type": "boolean"
          },
          "professionBlock": {
            "type": "string",
            "minLength": 1,
            "maxLength": 80
          }
        }
      },
      "conversationContext": {
        "$ref": "conversation-context.v1.schema.json"
      },
      "allowedRoutes": {
        "type": "array",
        "minItems": 1,
        "maxItems": 8,
        "uniqueItems": true,
        "items": {
          "$ref": "#/$defs/route"
        }
      },
      "policy": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "allowSkip",
          "allowRelatedChanges",
          "allowSideQuestions",
          "allowRecruiterRequest",
          "highRiskRequiresVerification"
        ],
        "properties": {
          "allowSkip": {
            "type": "boolean"
          },
          "allowRelatedChanges": {
            "type": "boolean"
          },
          "allowSideQuestions": {
            "type": "boolean"
          },
          "allowRecruiterRequest": {
            "type": "boolean"
          },
          "highRiskRequiresVerification": {
            "type": "boolean"
          }
        }
      },
      "release": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "builderVersion",
          "builderHash",
          "contractVersion",
          "contractHash",
          "questionCopyVersion",
          "policyVersion",
          "contextVersion",
          "contextHash"
        ],
        "properties": {
          "builderVersion": {
            "$ref": "#/$defs/releaseId"
          },
          "builderHash": {
            "$ref": "#/$defs/hash"
          },
          "contractVersion": {
            "const": "turn-snapshot.v2"
          },
          "contractHash": {
            "$ref": "#/$defs/hash"
          },
          "questionCopyVersion": {
            "$ref": "#/$defs/releaseId"
          },
          "policyVersion": {
            "$ref": "#/$defs/releaseId"
          },
          "contextVersion": {
            "$ref": "#/$defs/releaseId"
          },
          "contextHash": {
            "$ref": "#/$defs/hash"
          }
        }
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "opaqueVersion": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128
      },
      "hash": {
        "type": "string",
        "pattern": "^[a-f0-9]{64}$"
      },
      "releaseId": {
        "type": "string",
        "minLength": 1,
        "maxLength": 80,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "language": {
        "type": "string",
        "minLength": 2,
        "maxLength": 16,
        "pattern": "^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$"
      },
      "route": {
        "type": "string",
        "enum": [
          "ANSWER_CURRENT",
          "CORRECTION",
          "SIDE_QUESTION",
          "SESSION_QUESTION",
          "RECRUITER_REQUEST",
          "SKIP",
          "AMBIGUOUS",
          "UNSUPPORTED"
        ]
      },
      "answerType": {
        "type": "string",
        "enum": [
          "TEXT",
          "TEXTAREA",
          "NUMBER",
          "BOOLEAN",
          "RADIO",
          "MULTISELECT",
          "DATE",
          "EMAIL",
          "FILE",
          "LIST_OBJECT",
          "ACTION"
        ]
      },
      "operation": {
        "type": "string",
        "enum": [
          "SET",
          "ADD",
          "REMOVE",
          "CLEAR"
        ]
      },
      "option": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "label",
          "aliases"
        ],
        "properties": {
          "id": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "label": {
            "type": "string",
            "minLength": 1,
            "maxLength": 240
          },
          "aliases": {
            "type": "array",
            "maxItems": 12,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      },
      "constraints": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "allowEmpty"
        ],
        "properties": {
          "allowEmpty": {
            "type": "boolean"
          },
          "minimum": {
            "type": "number"
          },
          "maximum": {
            "type": "number"
          },
          "minLength": {
            "type": "integer",
            "minimum": 0,
            "maximum": 4000
          },
          "maxLength": {
            "type": "integer",
            "minimum": 1,
            "maximum": 4000
          },
          "maxSelections": {
            "type": "integer",
            "minimum": 1,
            "maximum": 100
          },
          "format": {
            "type": "string",
            "enum": [
              "NONE",
              "EMAIL",
              "DATE",
              "PHONE",
              "POSTCODE"
            ]
          }
        }
      },
      "question": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "questionKey",
          "questionVersion",
          "answerType",
          "required",
          "prompt",
          "constraints",
          "options",
          "allowedObjectFields",
          "highRisk"
        ],
        "properties": {
          "questionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "questionVersion": {
            "$ref": "#/$defs/opaqueVersion"
          },
          "answerType": {
            "$ref": "#/$defs/answerType"
          },
          "required": {
            "type": "boolean"
          },
          "prompt": {
            "type": "string",
            "minLength": 1,
            "maxLength": 1000
          },
          "constraints": {
            "$ref": "#/$defs/constraints"
          },
          "options": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "$ref": "#/$defs/option"
            }
          },
          "allowedObjectFields": {
            "type": "array",
            "maxItems": 20,
            "items": {
              "$ref": "#/$defs/objectFieldDefinition"
            }
          },
          "highRisk": {
            "type": "boolean"
          }
        }
      },
      "objectFieldDefinition": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "key",
          "answerType",
          "required",
          "allowedOptionIds"
        ],
        "properties": {
          "key": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "answerType": {
            "type": "string",
            "enum": [
              "TEXT",
              "TEXTAREA",
              "NUMBER",
              "BOOLEAN",
              "RADIO",
              "DATE",
              "EMAIL"
            ]
          },
          "required": {
            "type": "boolean"
          },
          "allowedOptionIds": {
            "type": "array",
            "maxItems": 100,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          }
        }
      },
      "relatedTarget": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "questionKey",
          "questionVersion",
          "targetRevision",
          "targetLabel",
          "answerType",
          "allowedOperations",
          "options",
          "allowedOptionIds",
          "allowedObjectFields",
          "highRisk",
          "requiresVerification"
        ],
        "properties": {
          "questionKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "questionVersion": {
            "$ref": "#/$defs/opaqueVersion"
          },
          "targetRevision": {
            "$ref": "#/$defs/opaqueVersion"
          },
          "targetLabel": {
            "type": "string",
            "minLength": 1,
            "maxLength": 160
          },
          "answerType": {
            "$ref": "#/$defs/answerType"
          },
          "allowedOperations": {
            "type": "array",
            "minItems": 1,
            "maxItems": 4,
            "uniqueItems": true,
            "items": {
              "$ref": "#/$defs/operation"
            }
          },
          "options": {
            "type": "array",
            "maxItems": 100,
            "items": {
              "$ref": "#/$defs/option"
            }
          },
          "allowedOptionIds": {
            "type": "array",
            "maxItems": 100,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 120
            }
          },
          "allowedObjectFields": {
            "type": "array",
            "maxItems": 20,
            "items": {
              "$ref": "#/$defs/objectFieldDefinition"
            }
          },
          "highRisk": {
            "type": "boolean"
          },
          "requiresVerification": {
            "type": "boolean"
          }
        }
      }
    }
  },
  "understand-request.v3.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/understand-request.v3.schema.json",
    "title": "UnderstandRequestV3",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "snapshot",
      "checklist",
      "unvoicedCommits",
      "candidateInput",
      "totalDeadlineMs",
      "contextHash"
    ],
    "properties": {
      "schemaVersion": {
        "const": "understand-request.v3"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "snapshot": {
        "$ref": "turn-snapshot.v2.schema.json"
      },
      "checklist": {
        "$ref": "checklist-state.v1.schema.json"
      },
      "unvoicedCommits": {
        "type": "array",
        "maxItems": 20,
        "items": {
          "$ref": "#/$defs/unvoicedCommit"
        }
      },
      "candidateInput": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "text",
          "trust",
          "selectedOptionId"
        ],
        "properties": {
          "text": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4000
          },
          "trust": {
            "const": "UNTRUSTED_CANDIDATE_INPUT"
          },
          "selectedOptionId": {
            "type": [
              "string",
              "null"
            ],
            "minLength": 1,
            "maxLength": 120
          }
        }
      },
      "totalDeadlineMs": {
        "type": "integer",
        "minimum": 100,
        "maximum": 60000
      },
      "contextHash": {
        "$ref": "turn-snapshot.v2.schema.json#/$defs/hash"
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "unvoicedCommit": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fieldKey",
          "targetRevision",
          "valueSummary"
        ],
        "properties": {
          "fieldKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "targetRevision": {
            "type": [
              "number",
              "null"
            ]
          },
          "valueSummary": {
            "type": "string",
            "minLength": 1,
            "maxLength": 240
          }
        }
      }
    }
  },
  "understand-result.v3.schema.json": {
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "$id": "https://optima.internal/schemas/understand-result.v3.schema.json",
    "title": "UnderstandResultV3",
    "type": "object",
    "additionalProperties": false,
    "required": [
      "schemaVersion",
      "turnId",
      "proposals",
      "sideIntents",
      "safety",
      "detectedLanguage"
    ],
    "properties": {
      "schemaVersion": {
        "const": "understand-result.v3"
      },
      "turnId": {
        "$ref": "#/$defs/id"
      },
      "proposals": {
        "type": "array",
        "maxItems": 20,
        "items": {
          "$ref": "#/$defs/proposal"
        }
      },
      "sideIntents": {
        "type": "array",
        "maxItems": 2,
        "uniqueItems": true,
        "items": {
          "$ref": "turn-decision.v2.schema.json#/properties/sideIntents/items"
        }
      },
      "safety": {
        "$ref": "turn-decision.v2.schema.json#/properties/safety"
      },
      "detectedLanguage": {
        "$ref": "turn-decision.v2.schema.json#/$defs/language"
      }
    },
    "$defs": {
      "id": {
        "type": "string",
        "minLength": 1,
        "maxLength": 128,
        "pattern": "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
      },
      "proposal": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fieldKey",
          "operation",
          "value",
          "evidence",
          "certainty",
          "targetRevision"
        ],
        "properties": {
          "fieldKey": {
            "type": "string",
            "minLength": 1,
            "maxLength": 120
          },
          "operation": {
            "type": "string",
            "enum": [
              "SET",
              "ADD",
              "REMOVE"
            ]
          },
          "value": {
            "$ref": "turn-decision.v2.schema.json#/$defs/typedValue"
          },
          "evidence": {
            "$ref": "turn-decision.v2.schema.json#/$defs/requiredEvidence"
          },
          "certainty": {
            "$ref": "turn-decision.v2.schema.json#/$defs/certainty"
          },
          "targetRevision": {
            "type": [
              "number",
              "null"
            ]
          }
        }
      }
    }
  }
});
export const contractSchemaHashes = Object.freeze({
  "candidate-reply.v1.schema.json": "a4ec743c92cb5f3ed2fe4fcb6dc0ce1e9108aa45225430b41fae667eff7a4cc1",
  "checklist-state.v1.schema.json": "4d5456c2c4cfbf594504b7dcd5b7bb4ecd4a9e097992b853ba63e81e11e1d84e",
  "commit-outcome.v1.schema.json": "ca51371cebecd0a0a96993c29c37b7985605cec098ec9b946aafcb9a770013c1",
  "compose-request.v3.schema.json": "4ff21b28fa70bc89288eda6e6e873dcf8f94638139558a1fe1aa9705f084646b",
  "compose-verdict.v1.schema.json": "1cb2a5fac2133fa876f26e3e9cf5602adcdd24fe5247dba6a23b8ad1215305dd",
  "composed-reply.v3.schema.json": "387ca136861bfbab88efc6d1ead19c793019b3f8e45f14e05e0e15c12d0b6469",
  "conversation-context.v1.schema.json": "51b63f83ca8e9eb877fc35d5f55c9659c0864e023d1737b9ecdc82453bb12048",
  "grounded-answer.v1.schema.json": "6a2c7b3fd6b022f3154705a680430082f09da5b49af9570b886bf47801dff237",
  "lifecycle-event.v1.schema.json": "4d433552b862ca65d26799620db05582207ef4ada50a1195a68b4bbe646d966d",
  "parse-route-request.v1.schema.json": "accb30359c5823dfaeac9bb4f85827cb60b51662cb640d72fc0102156bcde925",
  "parse-route-request.v2.schema.json": "d5d000f4fa684c12bd188d275a4a94b15f17d1589219d9fb911d74ae8597d810",
  "parse-route-response.v2.schema.json": "d14cc0ed6d4244c743b2734b317c69de082f1978f36566e14a364544ee1248cd",
  "provider-error.v1.schema.json": "5b5dc6010a2447992fb1571e737bc061e7a27e6af142503f404460f14b7c2644",
  "provider-generation.v1.schema.json": "3f160611516b9d01dc0bdb0bf60b42e0e6b60502c583d2f659272ef4b107d8e1",
  "steer-request.v3.schema.json": "8ae705fe12ac5c5edc640d6644251444e7778c1ecd92be220e58689dfe260137",
  "turn-decision.v2.schema.json": "63e0a78f1b5ff793d3fd50f8b89fd8d029e5e02ad7f5849d339cc82871654683",
  "turn-plan.v3.schema.json": "06d2c10cb8b780da31b46c91ba20b612e1c4d276d5f45813a8365bb223bef64b",
  "turn-result.v1.schema.json": "7305847084ab5508fac76c509e1e5ab37cd3227e8097b68413eaab53c43cdd48",
  "turn-snapshot.v2.schema.json": "a93e60927f25b18d8363ea09c1c6ac8828d423ae76b03c6da87ac91317130b45",
  "understand-request.v3.schema.json": "ce4392992f0ea016d59fdb4c995cc528c0e3b177c0d70b1d620e59852bca33a1",
  "understand-result.v3.schema.json": "04838bf88bd36cab2321f8226f38847716c01b455070df1d69253230075c1b6d"
});

function resolvePointer(root, pointer) {
  if (!pointer || pointer === '#') return root;
  if (!pointer.startsWith('#/')) throw new Error(`Unsupported schema reference fragment: ${pointer}`);
  return pointer.slice(2).split('/').reduce((value, segment) => value[segment.replaceAll('~1', '/').replaceAll('~0', '~')], root);
}

function resolveRef(documentName, documentRoot, ref) {
  const hashIndex = ref.indexOf('#');
  const target = hashIndex === -1 ? ref : ref.slice(0, hashIndex);
  const fragment = hashIndex === -1 ? '#' : ref.slice(hashIndex);
  if (!target) return { documentName, documentRoot, schema: resolvePointer(documentRoot, fragment) };
  const targetName = target.split('/').at(-1);
  const targetRoot = contractSchemas[targetName] ?? Object.values(contractSchemas).find((schema) => schema.$id === target);
  if (!targetRoot) throw new Error(`Unsupported schema reference document: ${target}`);
  return { documentName: targetName, documentRoot: targetRoot, schema: resolvePointer(targetRoot, fragment) };
}

function typeMatches(value, type) {
  if (type === 'null') return value === null;
  if (type === 'array') return Array.isArray(value);
  if (type === 'object') return value !== null && typeof value === 'object' && !Array.isArray(value);
  if (type === 'integer') return Number.isSafeInteger(value);
  if (type === 'number') return typeof value === 'number' && Number.isFinite(value);
  return typeof value === type;
}

function canonicalKey(value) {
  if (Array.isArray(value)) return `[${value.map(canonicalKey).join(',')}]`;
  if (value !== null && typeof value === 'object') {
    return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${canonicalKey(value[key])}`).join(',')}}`;
  }
  return JSON.stringify(value);
}

function isRfc3339DateTime(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.\d+)?(?:[zZ]|([+-])([01]\d|2[0-3]):([0-5]\d))$/.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1) return false;
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const monthDays = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return day <= monthDays[month - 1];
}

function validateNode(value, schema, documentName, documentRoot, path, issues) {
  if (schema.$ref) {
    const resolved = resolveRef(documentName, documentRoot, schema.$ref);
    return validateNode(value, resolved.schema, resolved.documentName, resolved.documentRoot, path, issues);
  }
  if (schema.oneOf) {
    const matches = schema.oneOf.filter((candidate) => {
      const candidateIssues = [];
      validateNode(value, candidate, documentName, documentRoot, path, candidateIssues);
      return candidateIssues.length === 0;
    }).length;
    if (matches !== 1) issues.push({ path, keyword: 'oneOf', message: `must match exactly one alternative (matched ${matches})` });
    return;
  }
  if (Object.hasOwn(schema, 'const') && !Object.is(value, schema.const)) {
    issues.push({ path, keyword: 'const', message: `must equal ${JSON.stringify(schema.const)}` });
    return;
  }
  if (schema.enum && !schema.enum.some((item) => Object.is(item, value))) {
    issues.push({ path, keyword: 'enum', message: 'contains an unsupported value' });
    return;
  }
  if (schema.type) {
    const types = Array.isArray(schema.type) ? schema.type : [schema.type];
    if (!types.some((type) => typeMatches(value, type))) {
      issues.push({ path, keyword: 'type', message: `must be ${types.join(' or ')}` });
      return;
    }
  }
  if (typeof value === 'string') {
    const length = Array.from(value).length;
    if (schema.minLength !== undefined && length < schema.minLength) issues.push({ path, keyword: 'minLength', message: `must contain at least ${schema.minLength} characters` });
    if (schema.maxLength !== undefined && length > schema.maxLength) issues.push({ path, keyword: 'maxLength', message: `must contain at most ${schema.maxLength} characters` });
    if (schema.pattern && !(new RegExp(schema.pattern, 'u')).test(value)) issues.push({ path, keyword: 'pattern', message: 'has an invalid format' });
    if (schema.format === 'date-time' && !isRfc3339DateTime(value)) issues.push({ path, keyword: 'format', message: 'must be an RFC 3339 date-time with timezone' });
  }
  if (typeof value === 'number') {
    if (schema.minimum !== undefined && value < schema.minimum) issues.push({ path, keyword: 'minimum', message: `must be >= ${schema.minimum}` });
    if (schema.maximum !== undefined && value > schema.maximum) issues.push({ path, keyword: 'maximum', message: `must be <= ${schema.maximum}` });
  }
  if (Array.isArray(value)) {
    if (schema.minItems !== undefined && value.length < schema.minItems) issues.push({ path, keyword: 'minItems', message: `must contain at least ${schema.minItems} items` });
    if (schema.maxItems !== undefined && value.length > schema.maxItems) issues.push({ path, keyword: 'maxItems', message: `must contain at most ${schema.maxItems} items` });
    if (schema.uniqueItems) {
      const keys = value.map(canonicalKey);
      if (new Set(keys).size !== keys.length) issues.push({ path, keyword: 'uniqueItems', message: 'must not contain duplicates' });
    }
    if (schema.items) value.forEach((item, index) => validateNode(item, schema.items, documentName, documentRoot, `${path}/${index}`, issues));
  }
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    for (const required of schema.required ?? []) {
      if (!Object.hasOwn(value, required)) issues.push({ path: `${path}/${required}`, keyword: 'required', message: 'is required' });
    }
    const properties = schema.properties ?? {};
    for (const [key, child] of Object.entries(value)) {
      if (Object.hasOwn(properties, key)) validateNode(child, properties[key], documentName, documentRoot, `${path}/${key}`, issues);
      else if (schema.additionalProperties === false) issues.push({ path: `${path}/${key}`, keyword: 'additionalProperties', message: 'is not allowed' });
    }
  }
}

function validate(value, schemaName) {
  const issues = [];
  const schema = contractSchemas[schemaName];
  validateNode(value, schema, schemaName, schema, '$', issues);
  return { valid: issues.length === 0, issues };
}

function assertion(name, result) {
  if (!result.valid) {
    const detail = result.issues.map((issue) => `${issue.path}: ${issue.message}`).join('; ');
    throw new TypeError(`Invalid ${name}: ${detail}`);
  }
}

export const validateParseRouteRequestV1 = (value) => validate(value, 'parse-route-request.v1.schema.json');
export const validateTurnResultV1 = (value) => validate(value, 'turn-result.v1.schema.json');
export const validateLifecycleEventV1 = (value) => validate(value, 'lifecycle-event.v1.schema.json');
export const validateConversationContextV1 = (value) => validate(value, 'conversation-context.v1.schema.json');
export const validateTurnSnapshotV2 = (value) => validate(value, 'turn-snapshot.v2.schema.json');
export const validateTurnDecisionV2 = (value) => validate(value, 'turn-decision.v2.schema.json');
export const validateParseRouteRequestV2 = (value) => validate(value, 'parse-route-request.v2.schema.json');
export const validateParseRouteResponseV2 = (value) => validate(value, 'parse-route-response.v2.schema.json');
export const validateCommitOutcomeV1 = (value) => validate(value, 'commit-outcome.v1.schema.json');
export const validateCandidateReplyV1 = (value) => validate(value, 'candidate-reply.v1.schema.json');
export const validateGroundedAnswerV1 = (value) => validate(value, 'grounded-answer.v1.schema.json');
export const validateProviderGenerationV1 = (value) => validate(value, 'provider-generation.v1.schema.json');
export const validateProviderErrorV1 = (value) => validate(value, 'provider-error.v1.schema.json');
export const validateChecklistStateV1 = (value) => validate(value, 'checklist-state.v1.schema.json');
export const validateUnderstandRequestV3 = (value) => validate(value, 'understand-request.v3.schema.json');
export const validateUnderstandResultV3 = (value) => validate(value, 'understand-result.v3.schema.json');
export const validateSteerRequestV3 = (value) => validate(value, 'steer-request.v3.schema.json');
export const validateTurnPlanV3 = (value) => validate(value, 'turn-plan.v3.schema.json');
export const validateComposeRequestV3 = (value) => validate(value, 'compose-request.v3.schema.json');
export const validateComposedReplyV3 = (value) => validate(value, 'composed-reply.v3.schema.json');
export const validateComposeVerdictV1 = (value) => validate(value, 'compose-verdict.v1.schema.json');
export function assertParseRouteRequestV1(value) { const result = validateParseRouteRequestV1(value); assertion('ParseRouteRequestV1', result); }
export function assertTurnResultV1(value) { const result = validateTurnResultV1(value); assertion('TurnResultV1', result); }
export function assertLifecycleEventV1(value) { const result = validateLifecycleEventV1(value); assertion('ConversationLifecycleEventV1', result); }
export function assertConversationContextV1(value) { const result = validateConversationContextV1(value); assertion('ConversationContextV1', result); }
export function assertTurnSnapshotV2(value) { const result = validateTurnSnapshotV2(value); assertion('TurnSnapshotV2', result); }
export function assertTurnDecisionV2(value) { const result = validateTurnDecisionV2(value); assertion('TurnDecisionV2', result); }
export function assertParseRouteRequestV2(value) { const result = validateParseRouteRequestV2(value); assertion('ParseRouteRequestV2', result); }
export function assertParseRouteResponseV2(value) { const result = validateParseRouteResponseV2(value); assertion('ParseRouteResponseV2', result); }
export function assertCommitOutcomeV1(value) { const result = validateCommitOutcomeV1(value); assertion('CommitOutcomeV1', result); }
export function assertCandidateReplyV1(value) { const result = validateCandidateReplyV1(value); assertion('CandidateReplyV1', result); }
export function assertGroundedAnswerV1(value) { const result = validateGroundedAnswerV1(value); assertion('GroundedAnswerV1', result); }
export function assertProviderGenerationV1(value) { const result = validateProviderGenerationV1(value); assertion('ProviderGenerationV1', result); }
export function assertProviderErrorV1(value) { const result = validateProviderErrorV1(value); assertion('ProviderErrorV1', result); }
export function assertChecklistStateV1(value) { const result = validateChecklistStateV1(value); assertion('ChecklistStateV1', result); }
export function assertUnderstandRequestV3(value) { const result = validateUnderstandRequestV3(value); assertion('UnderstandRequestV3', result); }
export function assertUnderstandResultV3(value) { const result = validateUnderstandResultV3(value); assertion('UnderstandResultV3', result); }
export function assertSteerRequestV3(value) { const result = validateSteerRequestV3(value); assertion('SteerRequestV3', result); }
export function assertTurnPlanV3(value) { const result = validateTurnPlanV3(value); assertion('TurnPlanV3', result); }
export function assertComposeRequestV3(value) { const result = validateComposeRequestV3(value); assertion('ComposeRequestV3', result); }
export function assertComposedReplyV3(value) { const result = validateComposedReplyV3(value); assertion('ComposedReplyV3', result); }
export function assertComposeVerdictV1(value) { const result = validateComposeVerdictV1(value); assertion('ComposeVerdictV1', result); }
